import ReactDOM from "react-dom";
import React from "react";

/**
 * ConfirmModal — même format que UserInfoModal (header
 * titre + croix, body, footer avec deux boutons).
 *
 * Usage :
 *   <ConfirmModal
 *     open={!!itemToDelete}
 *     title="Supprimer l'utilisateur"
 *     message={`Supprimer "${itemToDelete?.nom}" ? Cette action est irréversible.`}
 *     confirming={deletingId === itemToDelete?.id}
 *     onConfirm={handleConfirm}
 *     onCancel={() => setItemToDelete(null)}
 *   />
 */
export function ConfirmModal({ open, title = "Confirmation", message, confirmLabel = "Supprimer", confirming = false, onConfirm, onCancel }) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <>
      <div
        className="modal modal-blur fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 2000 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" onClick={onCancel} />
            </div>

            {/* BODY */}
            <div className="modal-body">
              <p className="mb-0">{message}</p>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={confirming}>
                Annuler
              </button>
              <button type="button" className="btn btn-danger" onClick={onConfirm} disabled={confirming}>
                {confirming ? "Suppression…" : confirmLabel}
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* BACKDROP */}
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1999 }}
        onClick={onCancel}
      />
    </>,
    document.body
  );
}
